<!-- 缺陷平均响应时间 -->
<template>
  <div>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">缺陷平均响应时间</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间：创建时间</p>
            <p>计算方式: 自然日计算</p>
            <p>统计维度: 状态为DONE的非生产缺陷</p>
            <p>描述：所选时间段内团队所负责缺陷的平均响应时间，缺陷平均响应时间 = 缺陷总响应时间 / 缺陷数</p>
            <p>单个缺陷响应时间 = 最后一次置为Testing状态时间 - 缺陷创建时间</p>
            <p>排序：陷响应时间正序（默认）</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div :id="id" :style="{ height: height, width: width }" />
    </a-card>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <TeamIssueAverageModal ref="teamIssueAverageModalRef" />
    <br />
    <a-row :span="24">
      <a-col class="customer-col" :span="12">
        <issue-response-num :data="data" />
      </a-col>
      <a-col class="customer-col" :span="12">
        <issue-stage-num :data="issueResponseData" />
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { issueResponseTimeTeam } from '@/api/data/issue';
import TeamIssueAverageModal from './TeamIssueAverageModal.vue';
import IssueResponseNum from './IssueResponseNum.vue';
import IssueStageNum from './IssueStageNum.vue';

export default {
  components: {
    TeamIssueAverageModal,
    IssueResponseNum,
    IssueStageNum
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      id: 'task-point-average',
      loading: true,
      showModal: 'team',
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<b>' + params[0].name + '</b><br/>';
            formatter += params[0].marker + params[0].seriesName + '<span style="float: right; margin-left:16px"><b style="color: #5A6FC0;">' + params[0].value + '</b> 小时</span><br/>';
            formatter += params[1].marker + params[1].seriesName + '<span style="float: right; margin-left:16px"><b style="color: #5A6FC0;">' + params[1].value + '</b> 个</span><br/>';
            return formatter;
          }
        },
        grid: {
          left: '4%',
          right: '5%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: false,
            realtime: true,
            button: 0,
            height: 18
          }
        ]
      },
      data: [],
      issueResponseData: {}
    };
  },
  watch: {
    filterForm() {
      this.getIssueResponseTimeTeam();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line'); // 折线图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById(this.id));
    const self = this;
    this.myChart.getZr().on('click', params => {
      const pointInPixel = [params.offsetX, params.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (self.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        this.$refs.teamIssueAverageModalRef.open(this.data[index], this.data[index].issues_detail);
      }
    }
    );
    setTimeout(() => {
      this.getIssueResponseTimeTeam();
    }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用 */
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      setTimeout(() => {
        this.myChart.resize();
      }, 0);
    },
    getIssueResponseTimeTeam() {
      this.loading = true;
      issueResponseTimeTeam({ ...this.filterForm, sorter: 'average_response_time', show_modal: this.showModal })
        .then(res => {
          this.data = res.data.items;
          this.issueResponseData = res.data;
          const x_axis = [];
          const average_series = [];
          const issue_count_series = [];
          this.data.forEach(el => {
            x_axis.push(this.showModal === 'team' ? el.team_name : el.nickname);
            average_series.push(el.average_response_time);
            issue_count_series.push(el.issue_count);
          });

          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top',
                formatter: '{c}小时'
              },
              name: '缺陷平均响应时间',
              data: average_series
            },
            {
              type: 'bar',
              show: false,
              name: '缺陷数量',
              label: {
                show: true,
                position: 'top'
              },
              data: issue_count_series
            }
          ];
          this.drawChart();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
.customer-col {
  margin-top: 5px;
}
</style>
